import { render, staticRenderFns } from "./VxCellGiftKeyStatus.vue?vue&type=template&id=58b0149b&"
import script from "./VxCellGiftKeyStatus.vue?vue&type=script&lang=js&"
export * from "./VxCellGiftKeyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports